// The address of a course's own page on the customer's website. This mirrors the server's rule
// (CourseOwnPage.Normalise), so the form can show the cleaned address and any problem straight away. The server checks again.

export const OWN_PAGE_MAX_LENGTH = 500

const MESSAGE = 'Enter the full web address of the page, like https://example.com/first-aid. Only http and https addresses can be used.'

export type OwnPageResult = { value: string | null; error: string | null }

/** Blank is fine. An address typed without a scheme gets "https://" added. Anything that is not an http(s) address is an error. */
export function normaliseOwnPage(input: string | null | undefined): OwnPageResult {
  const typed = input?.trim() ?? ''
  if (typed === '') return { value: null, error: null }
  if (typed.length > OWN_PAGE_MAX_LENGTH) return { value: typed, error: `The address must be ${OWN_PAGE_MAX_LENGTH} characters or fewer.` }
  if (/\s/.test(typed) || typed.startsWith('//')) return { value: typed, error: MESSAGE }

  let value = typed
  if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) {
    if (/^(javascript|data|vbscript|file|blob|about|mailto|tel|sms):/i.test(value)) return { value: typed, error: MESSAGE }
    value = `https://${value}`
  }

  try {
    const url = new URL(value)
    if ((url.protocol !== 'http:' && url.protocol !== 'https:') || !url.hostname) return { value: typed, error: MESSAGE }
  } catch {
    return { value: typed, error: MESSAGE }
  }
  return { value, error: null }
}
